module.exports = __WEBPACK_EXTERNAL_MODULE_17__;


//////////////////
// WEBPACK FOOTER
// external "angular-cookies"
// module id = 17
// module chunks = 0